<template>
    <div>
        <!-- ECharts图表容器 -->
        <div ref="barChart" style="width: 100%; height: 550px;"></div>
    </div>
</template>
  
<script>
import ClueService from "~/services/SaleClues";
import echarts from 'echarts';

export default {
    props:{
        params:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            count_data: {
                categories: [],
                data: [],
            },
        };
    },
    created(){
        this.getData(this.searcherModel);
    },
    mounted() {
        
    },
    methods: {
        getData() {
            ClueService.getChannelCountBar(this.params)
            .then(res=>{
                this.count_data = res.data;
                this.initChart();
            })
        },
        initChart() {
            const chartContainer = this.$refs.barChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);

            const options = {
                // title: {
                //     text: '渠道申请分析',
                // },
                color: [
                    '#5470c6',
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                    '#C280FF',
                    '#34B7FB',
                    '#81D3F8',
                    '#95F204',
                    '#F56C6C',
                    '#04D919',
                    '#FFA680',
                    '#B1DDF5',
                    '#CBE7F4',
                    '#D2F2A0',
                    '#F3C4C4',
                    '#A0E9A8',
                    '#F6D8CB',
                    '#8080FF',
                    '#FF4D00',
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    orient: 'horizontal', // 设置图例为水平布局
                    left: 'center', // 将图例居中对齐
                    top: 'top', // 放置在顶部
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.count_data.day_str,
                        // axisLabel:{
                        //     interval:0, //控制X轴刻度全部显示
                        //     rotate:45 //倾斜角度
                        // }
                    }
                ],
                yAxis: {
                    type: 'value'
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: false},
                        magicType: {show: true, type: ['line', 'bar', 'tiled']},
                        restore: {show: true},
                        saveAsImage: {show: true}
                    }
                },
                series: [
                    // {
                    //     data: this.count_data.count_num,
                    //     type: 'bar',
                    //     label: {
                    //         show: true,
                    //         position: 'top',
                    //         formatter: '{c}',
                    //     },
                    // }
                ],
                
            };
            this.count_data.count_num.forEach(item => {
                const nonZeroData = Object.values(item.children).some(value => value !== 0);
                if(nonZeroData){
                    options.series.push(
                        {
                            name: item.name,
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            data: Object.values(item.children)
                            // data: Object.values(item.children).map(value => value === 0 ? null : value)
                        },
                    );
                }
            });
            myChart.setOption(options);
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/clue/echarts/BarChart.vue